import { createFileRoute, Link } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/elvion-group")({
  head: () => ({
    meta: [
      { title: "Elvion Group Nederland — Technisch installatiebedrijf in Nederland" },
      {
        name: "description",
        content:
          "Elvion Group Nederland is een Nederlands technisch installatiebedrijf voor camerabewaking, groepenkasten, laadpalen en beveiliging. Bekijk merkinformatie, diensten en contact.",
      },
      { property: "og:title", content: "Elvion Group Nederland — Officiële merkpagina" },
      {
        property: "og:description",
        content:
          "Officiële merkpagina van Elvion Group Nederland: bedrijfsinformatie, diensten, vestigingen en contact.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://elvion-group.nl/elvion-group" },
    ],
    links: [{ rel: "canonical", href: "https://elvion-group.nl/elvion-group" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Elvion Group Nederland",
          alternateName: ["Elvion", "Elvion Group Nederland", "Elvion Group Nederland NL", "Elvion Nederland"],
          url: "https://elvion-group.nl",
          logo: "https://elvion-group.nl/favicon.ico",
          description:
            "Elvion Group Nederland is een Nederlands technisch installatiebedrijf gespecialiseerd in camerabewaking, groepenkasten, laadpalen en beveiligingsoplossingen voor particulieren en bedrijven.",
          areaServed: "NL",
          sameAs: ["https://elvion-group.nl"],
          contactPoint: {
            "@type": "ContactPoint",
            contactType: "customer service",
            areaServed: "NL",
            availableLanguage: ["Dutch", "English"],
            url: "https://elvion-group.nl/klantenservice",
          },
        }),
      },
    ],
  }),
  component: ElvionGroupPage,
});

function ElvionGroupPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header variant="shop" />
      <main className="container mx-auto px-4 py-16 max-w-4xl">
        <header className="mb-12">
          <p className="text-sm uppercase tracking-wide text-muted-foreground mb-2">
            Officiële merkpagina
          </p>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Elvion Group Nederland — Technisch installatiebedrijf in Nederland
          </h1>
          <p className="text-lg text-muted-foreground">
            Elvion Group Nederland is de Nederlandse specialist in camerabewaking,
            groepenkasten, laadpalen en beveiliging voor particulieren en
            bedrijven.
          </p>
        </header>

        <section className="prose prose-neutral max-w-none mb-12">
          <h2>Over Elvion Group Nederland</h2>
          <p>
            Elvion Group Nederland is een krachtige organisatie van gespecialiseerde
            technische ondernemingen in Nederland. Wij combineren jarenlange
            ervaring in elektrotechniek, beveiliging en duurzame energie tot
            één betrouwbare partner voor woning- en bedrijfsinstallaties.
          </p>

          <h2>Onze diensten</h2>
          <ul>
            <li>
              <strong>Camerabewaking</strong> — professionele installatie en
              onderhoud
            </li>
            <li>
              <strong>Groepenkasten</strong> — vervangen, uitbreiden en keuren
            </li>
            <li>
              <strong>Laadpalen</strong> — installatie voor thuis en zakelijk
            </li>
            <li>
              <strong>Beveiliging</strong> — alarmsystemen en toegangscontrole
            </li>
            <li>
              <strong>Zakelijke installaties</strong> — voor MKB en corporate
            </li>
          </ul>

          <h2>Waarom Elvion Group Nederland?</h2>
          <ul>
            <li>Landelijke dekking met lokale installateurs</li>
            <li>Gecertificeerde monteurs en A-merk producten</li>
            <li>Transparante prijzen en snelle offertes</li>
            <li>Klantenservice in het Nederlands</li>
          </ul>

          <h2>Bedrijfsinformatie</h2>
          <p>
            <strong>Merknaam:</strong> Elvion Group Nederland
            <br />
            <strong>Website:</strong> elvion-group.nl
            <br />
            <strong>Werkgebied:</strong> Nederland
            <br />
            <strong>Branche:</strong> Technisch installatiebedrijf
          </p>
        </section>

        <section className="grid gap-4 sm:grid-cols-3">
          <Button asChild>
            <Link to="/offerte-aanvragen">Offerte aanvragen</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/klantenservice">Klantenservice</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/over-ons">Over ons</Link>
          </Button>
        </section>
      </main>
      <Footer />
    </div>
  );
}
